import React from 'react';
import { A4, PDF_FONT_FAMILY } from './pdfEngine';

/**
 * Shared A4 page frame used by ALL PDF documents (lists, reports and
 * single-record prints).
 *
 * Standard layout (identical across the app):
 *  - double black frame
 *  - faint centered watermark (company logo)
 *  - HeaderAce.png banner (company logo + name) with double rule
 *  - report title + report date + applied-filters line
 *  - content area (children)
 *  - FooterAce.png banner (website / email / company info) fixed at bottom
 */
const publicUrl = process.env.PUBLIC_URL || '';
export const PDF_HEADER_IMG = `${publicUrl}/HeaderAce.png`;
export const PDF_FOOTER_IMG = `${publicUrl}/FooterAce.png`;
export const PDF_WATERMARK_IMG = `${publicUrl}/ACE.png`;

/** Reserved footer strip height (px) — keeps content clear of the footer. */
export const PDF_FOOTER_RESERVE_PX = 120;

const PdfA4Page = ({
  id,
  isRTL = true,
  title,
  reportDate,
  filtersSummary,
  children,
  showTitle = true,
}) => {
  const displayDate =
    reportDate || new Date().toLocaleDateString('en-GB');

  return (
    <div
      id={id}
      style={{
        width: `${A4.WIDTH_PX}px`,
        minHeight: `${A4.HEIGHT_PX}px`,
        backgroundColor: '#ffffff',
        color: '#000000',
        fontFamily: PDF_FONT_FAMILY,
        fontWeight: 'bold',
        padding: '40px',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          border: '5px solid #000',
          padding: '3px',
          backgroundColor: '#ffffff',
          boxSizing: 'border-box',
          width: '100%',
          minHeight: `${A4.INNER_HEIGHT_PX + 10}px`,
        }}
      >
        <div
          style={{
            border: '2px solid #000',
            minHeight: `${A4.INNER_HEIGHT_PX}px`,
            height: `${A4.INNER_HEIGHT_PX}px`,
            padding: '18px 18px 10px',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            fontFamily: PDF_FONT_FAMILY,
            fontWeight: 'bold',
            direction: isRTL ? 'rtl' : 'ltr',
            backgroundColor: '#ffffff',
          }}
        >
          {/* Watermark */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundImage: `url(${PDF_WATERMARK_IMG})`,
              backgroundSize: '95%',
              backgroundPosition: 'center center',
              backgroundRepeat: 'no-repeat',
              opacity: 0.08,
              zIndex: 0,
              pointerEvents: 'none',
            }}
          />
          <div
            style={{
              position: 'relative',
              zIndex: 1,
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            {/* Company header banner */}
            <img
              src={PDF_HEADER_IMG}
              alt="Header"
              style={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
                marginBottom: '8px',
                borderBottom: '4px double #000',
                paddingBottom: '8px',
                flexShrink: 0,
              }}
              crossOrigin="anonymous"
            />

            <div
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'visible',
                minHeight: 0,
                paddingBottom: `${PDF_FOOTER_RESERVE_PX}px`,
              }}
            >
              {showTitle && (
                <div
                  style={{
                    marginTop: '12px',
                    textAlign: 'center',
                    marginBottom: '12px',
                  }}
                >
                  <h2
                    style={{
                      fontSize: '20px',
                      fontWeight: '700',
                      color: '#000080',
                      margin: 0,
                    }}
                  >
                    {title}
                  </h2>
                  <div
                    style={{
                      fontSize: '11px',
                      color: '#333',
                      marginTop: '4px',
                    }}
                  >
                    {displayDate}
                  </div>
                  {filtersSummary ? (
                    <div
                      style={{
                        fontSize: '11px',
                        color: '#333',
                        marginTop: '2px',
                      }}
                    >
                      {filtersSummary}
                    </div>
                  ) : null}
                </div>
              )}
              {children}
            </div>

            {/* Company footer banner — fixed at the bottom of every page */}
            <div
              style={{
                position: 'absolute',
                bottom: '10px',
                left: '18px',
                right: '18px',
                flexShrink: 0,
              }}
            >
              <img
                src={PDF_FOOTER_IMG}
                alt="Footer"
                style={{
                  width: '100%',
                  height: 'auto',
                  objectFit: 'contain',
                  borderTop: '4px double #000',
                  paddingTop: '8px',
                }}
                crossOrigin="anonymous"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfA4Page;
